<template>
    <div class="TeamGraph text-center">
      <span class="graph" v-if="team">
        <div class="red" :style="{transform: 'rotate(-' + angle + 'deg)'}"></div>
        <div class="blue" :style="{transform: 'rotate(' + (180 - angle) + 'deg)'}"></div>
        <div class="score">
          <span>{{ team.red.score }}</span>
          <span>{{ team.blue.score }}</span>
        </div>
      </span>
    </div>
</template>

<script>
export default {
  name: 'TeamGraph',
  props: ['team'],
  computed: {
    angle () {
      try {
        const red = this.team.red.score
        const blue = this.team.blue.score
        return red === 0 && blue === 0 ? 90 : blue / (red + blue) * 180
      } catch (err) {
        return 90
      }
    }
  }
}
</script>

<style scoped>
.graph {
  display: inline-block;
  position: relative;
  width: 102px;
  height: 51px;
  overflow:hidden;
  border-bottom: solid 1px gray;
}
.graph .red,
.graph .blue {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 50px;
  border: solid 1px gray;
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
  transform-origin: 50% 100%;
  transition: all 1s ease-in-out;
}
.graph .red {
  background: #6d2321;
}
.graph .blue {
  background: #4b5b76;
}
.graph .score {
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: flex-end;
  margin: 0 .4em;
  height: 100%;
  color: white;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/TeamGraph.vue